<template>
  <div class="d-flex justify-content-center">
    <img width="64px" height="64px" src="@/assets/images/rolling.svg" alt="loader" class="loader mt-2 mb-2" />
  </div>
</template>
<script>
export default {
  name: "Loader",
};
</script>

<style>
.loader {
  width: 40px;
  height: 40px;
}
</style>
